import * as React from 'react';

const SvgIconSocialite = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={25} height={24} fill="none" {...props}>
    <path
      d="M23.32.75v22.5"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      clipRule="evenodd"
      d="M11.014 6.706c.327-.833-.345-1.877-1.502-2.331-1.157-.454-2.36-.147-2.686.686-.327.833.345 1.877 1.502 2.33 1.156.455 2.36.148 2.686-.685zM16.735 7.454c1.11-.436 1.735-1.493 1.394-2.36-.34-.868-1.517-1.218-2.627-.782-1.11.436-1.735 1.493-1.394 2.36.34.868 1.517 1.218 2.627.782z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      clipRule="evenodd"
      d="M19.928 1.945a2.428 2.428 0 01-2.496-.312 3.52 3.52 0 00-4.523.173l-.389.348-.39-.348a3.52 3.52 0 00-4.524-.173c-.719.562-1.67.68-2.496.312L1.72.75c-.021 1.28.037 2.562.175 3.835.323 2.447 1.804 4.562 3.942 5.63a6.815 6.815 0 006.683-.323 6.814 6.814 0 006.683.324c2.138-1.068 3.619-3.184 3.941-5.631.139-1.273.198-2.554.176-3.835l-3.392 1.195z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SvgIconSocialite;
